export enum PositionInfoType {
    None,
    PLByCurrency,
    AverageOpenPrice,
    BreakEven,
    NetQTY,
    LongQty,
    ShortQty
}
